<template>
  <div class="copyright-page">
    <header class="page-topbar">
      <div class="topbar-inner">
        <a class="brand" href="/#/" @click.prevent="goHome">
          <img class="brand-mark" src="/favicon.png" alt="" />
          <span class="brand-copy">
            <span class="brand-text">星空素材网</span>
            <span class="brand-sub">版权中心</span>
          </span>
        </a>
        <button type="button" class="back-btn" @click="goHome">
          ← 返回素材库
        </button>
      </div>
    </header>

    <main class="page-main">
      <section class="hero-block">
        <p class="kicker">COPYRIGHT CENTER</p>
        <h1>版权中心</h1>
        <p class="lead">
          本站素材已完成作品自愿登记。以下为版权证书图片，可直接查看与核对。
        </p>
        <div class="hero-meta">
          <span>权利人：山西壹拾贰文化传媒有限公司</span>
          <span>登记机关：甘肃省版权局</span>
          <span>证书总数：{{ total }} 张</span>
        </div>
      </section>

      <section class="gallery-section">
        <div class="section-head">
          <h2>版权证书</h2>
          <p>第 {{ currentPage }} / {{ totalPages }} 页</p>
        </div>

        <div class="image-grid">
          <button
            type="button"
            class="image-card"
            v-for="id in pageIds"
            :key="id"
            @click="openDetail(id)"
          >
            <div class="thumb-wrap">
              <img
                :src="imageUrl(id)"
                :alt="`版权证书 ${id}`"
                loading="lazy"
                @error="onImgError(id, $event)"
              />
            </div>
            <div class="image-meta">
              <strong>证书 {{ id }}</strong>
              <span>点击查看大图</span>
            </div>
          </button>
        </div>

        <div class="pager" v-if="totalPages > 1">
          <button
            type="button"
            class="pager-btn"
            :disabled="currentPage <= 1"
            @click="goPage(currentPage - 1)"
          >
            上一页
          </button>
          <div class="pager-jump">
            <span>前往</span>
            <input
              v-model.number="jumpPage"
              type="number"
              min="1"
              :max="totalPages"
              @keyup.enter="goPage(jumpPage)"
            />
            <span>/ {{ totalPages }}</span>
            <button type="button" class="pager-go" @click="goPage(jumpPage)">
              跳转
            </button>
          </div>
          <button
            type="button"
            class="pager-btn"
            :disabled="currentPage >= totalPages"
            @click="goPage(currentPage + 1)"
          >
            下一页
          </button>
        </div>
      </section>

      <section class="notice-section">
        <h2>使用说明</h2>
        <ul>
          <li>证书内容以本页展示图片为准，可点击放大核对登记信息。</li>
          <li>付费购买后仅获得约定范围内的个人使用权，不代表获得素材版权。</li>
          <li>未经书面授权，不得二次售卖、公开分发或以其他方式侵害著作权。</li>
          <li>如需授权合作或维权协助，请通过页面客服联系处理。</li>
        </ul>
      </section>
    </main>

    <footer class="page-footer">
      <span>山西壹拾贰网络科技有限公司 / 山西壹拾贰文化传媒有限公司</span>
      <span>版权所有</span>
    </footer>

    <div class="detail-modal" v-if="activeId" @click.self="closeDetail">
      <div class="detail-panel" role="dialog" aria-modal="true">
        <header class="detail-head">
          <div>
            <h3>版权证书 {{ activeId }}</h3>
            <p>图片为准 · 可放大核对登记信息</p>
          </div>
          <div class="detail-head-actions">
            <a
              class="btn-open"
              :href="imageUrl(activeId)"
              target="_blank"
              rel="noreferrer nofollow"
            >
              新窗口打开
            </a>
            <a
              class="btn-download"
              :href="imageUrl(activeId)"
              :download="`版权证书-${activeId}.png`"
              target="_blank"
              rel="noreferrer nofollow"
            >
              下载图片
            </a>
            <button
              type="button"
              class="close-btn"
              @click="closeDetail"
              aria-label="关闭"
            >
              ×
            </button>
          </div>
        </header>
        <div class="detail-body">
          <button
            type="button"
            class="nav-side prev"
            :disabled="activeId <= 1"
            @click="shiftDetail(-1)"
            aria-label="上一张"
          >
            ‹
          </button>
          <img
            class="detail-image"
            :src="imageUrl(activeId)"
            :alt="`版权证书 ${activeId}`"
          />
          <button
            type="button"
            class="nav-side next"
            :disabled="activeId >= total"
            @click="shiftDetail(1)"
            aria-label="下一张"
          >
            ›
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

const total = 786;
const pageSize = 48;
const currentPage = ref(1);
const jumpPage = ref(1);
const activeId = ref(null);
const broken = ref({});

const totalPages = computed(() => Math.ceil(total / pageSize));

const pageIds = computed(() => {
  const start = (currentPage.value - 1) * pageSize + 1;
  const end = Math.min(currentPage.value * pageSize, total);
  const ids = [];
  for (let i = start; i <= end; i += 1) ids.push(i);
  return ids;
});

const imageUrl = (id) => `https://qiniu.manmcz.com/wp-content/banquan/${id}.png`;

const goPage = (page) => {
  const next = Math.min(Math.max(Number(page) || 1, 1), totalPages.value);
  currentPage.value = next;
  jumpPage.value = next;
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const openDetail = (id) => {
  if (broken.value[id]) return;
  activeId.value = id;
};

const closeDetail = () => {
  activeId.value = null;
};

const shiftDetail = (step) => {
  if (!activeId.value) return;
  const next = activeId.value + step;
  if (next < 1 || next > total) return;
  activeId.value = next;
};

const onImgError = (id, event) => {
  broken.value[id] = true;
  event.target.style.opacity = "0.25";
};

const goHome = () => {
  router.push({ path: "/" });
};

watch(currentPage, (page) => {
  jumpPage.value = page;
});
</script>

<style scoped lang="scss">
.copyright-page {
  min-height: 100vh;
  color: var(--xk-ink);
  background: var(--xk-page-bg);
  display: flex;
  flex-direction: column;
}

.page-topbar {
  position: sticky;
  top: 0;
  z-index: 50;
  backdrop-filter: blur(14px);
  background: var(--xk-topbar-bg);
  border-bottom: 1px solid var(--xk-line);
}

.topbar-inner {
  width: 100%;
  padding: 0.85rem clamp(1rem, 2.2vw, 2rem);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  text-decoration: none;
  color: var(--xk-ink);
}

.brand-mark {
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
  object-fit: cover;
  background: #0b1220;
  box-shadow: 0 4px 12px rgba(11, 120, 196, 0.18);
}

.brand-copy {
  display: flex;
  flex-direction: column;
  gap: 0.05rem;
  line-height: 1.1;
}

.brand-text {
  font-family: "ZCOOL KuaiLe", "Noto Sans SC", sans-serif;
  font-size: 1.28rem;
  letter-spacing: 0.04em;
}

.brand-sub {
  font-size: 0.68rem;
  color: var(--xk-muted);
  letter-spacing: 0.12em;
}

.back-btn {
  border: 1px solid var(--xk-line);
  background: var(--xk-panel-bg);
  color: var(--xk-ink);
  font: inherit;
  font-size: 0.88rem;
  padding: 0.45rem 0.85rem;
  border-radius: 0.65rem;
  cursor: pointer;

  &:hover {
    color: var(--xk-sky-deep);
  }
}

.page-main {
  width: min(1600px, 96vw);
  margin: 0 auto;
  padding: 1.75rem 0 3rem;
  flex: 1;
}

.hero-block {
  padding: 1.6rem 1.4rem 1.5rem;
  border-radius: 1.2rem;
  background:
    radial-gradient(ellipse 70% 90% at 100% 0%, rgba(26, 155, 232, 0.16), transparent 55%),
    var(--xk-panel-bg);
  border: 1px solid var(--xk-line);
}

.kicker {
  margin: 0 0 0.45rem;
  font-size: 0.72rem;
  letter-spacing: 0.16em;
  color: var(--xk-muted);
}

.hero-block h1 {
  margin: 0 0 0.65rem;
  font-family: "ZCOOL KuaiLe", "Noto Sans SC", sans-serif;
  font-size: clamp(1.8rem, 3vw, 2.3rem);
  font-weight: 400;
  letter-spacing: 0.04em;
}

.lead {
  margin: 0;
  max-width: 46rem;
  line-height: 1.7;
  color: var(--xk-muted);
  font-size: 0.95rem;
}

.hero-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.55rem;
  margin-top: 1.1rem;

  span {
    padding: 0.35rem 0.7rem;
    border-radius: 999px;
    background: var(--xk-soft);
    border: 1px solid var(--xk-line);
    font-size: 0.78rem;
    color: var(--xk-sky-deep);
  }
}

.gallery-section {
  margin-top: 1.75rem;
}

.section-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;

  h2 {
    margin: 0;
    font-size: 1.2rem;
  }

  p {
    margin: 0;
    color: var(--xk-muted);
    font-size: 0.86rem;
  }
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 0.85rem;
}

.image-card {
  border: 1px solid var(--xk-line);
  border-radius: 0.85rem;
  overflow: hidden;
  background: var(--xk-panel-bg);
  cursor: pointer;
  padding: 0;
  text-align: left;
  font: inherit;
  color: inherit;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 14px 28px rgba(15, 40, 70, 0.1);
  }
}

.thumb-wrap {
  aspect-ratio: 5 / 4;
  background: #f4efe4;
  display: grid;
  place-items: center;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
}

.image-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.35rem;
  padding: 0.5rem 0.65rem;

  strong {
    font-size: 0.82rem;
  }

  span {
    font-size: 0.7rem;
    color: var(--xk-muted);
    white-space: nowrap;
  }
}

.pager {
  margin-top: 1.35rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.75rem 1rem;
}

.pager-btn,
.pager-go {
  border: 1px solid var(--xk-line);
  background: var(--xk-panel-bg);
  color: var(--xk-ink);
  font: inherit;
  font-size: 0.86rem;
  padding: 0.45rem 0.85rem;
  border-radius: 0.55rem;
  cursor: pointer;

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
}

.pager-go,
.pager-btn:not(:disabled):hover {
  color: var(--xk-sky-deep);
}

.pager-jump {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  color: var(--xk-muted);
  font-size: 0.86rem;

  input {
    width: 4rem;
    height: 2rem;
    border: 1px solid var(--xk-line);
    border-radius: 0.45rem;
    text-align: center;
    font: inherit;
    background: var(--xk-panel-bg);
    color: var(--xk-ink);
  }
}

.notice-section {
  margin-top: 1.75rem;
  padding: 1.2rem 1.25rem;
  border-radius: 1rem;
  background: var(--xk-panel-bg);
  border: 1px solid var(--xk-line);

  h2 {
    margin: 0 0 0.75rem;
    font-size: 1.05rem;
  }

  ul {
    margin: 0;
    padding-left: 1.1rem;
  }

  li {
    margin-bottom: 0.45rem;
    line-height: 1.65;
    font-size: 0.9rem;
    color: var(--xk-muted);
  }
}

.page-footer {
  padding: 1rem 1.25rem 1.4rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.45rem 0.85rem;
  color: var(--xk-muted);
  font-size: 0.8rem;
  border-top: 1px solid var(--xk-line);
}

.detail-modal {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(8, 20, 36, 0.58);
  backdrop-filter: blur(4px);
}

.detail-panel {
  width: min(1100px, 100%);
  height: min(90vh, 920px);
  display: flex;
  flex-direction: column;
  border-radius: 1rem;
  overflow: hidden;
  background: var(--xk-panel-bg);
  border: 1px solid var(--xk-line);
  box-shadow: 0 24px 56px rgba(15, 40, 70, 0.3);
}

.detail-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.95rem 1.1rem;
  border-bottom: 1px solid var(--xk-line);

  h3 {
    margin: 0 0 0.25rem;
    font-size: 1.05rem;
  }

  p {
    margin: 0;
    color: var(--xk-muted);
    font-size: 0.82rem;
  }
}

.detail-head-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.btn-open,
.btn-download {
  border: 1px solid var(--xk-line);
  background: var(--xk-soft);
  color: var(--xk-sky-deep);
  font: inherit;
  font-size: 0.82rem;
  font-weight: 600;
  padding: 0.42rem 0.75rem;
  border-radius: 0.55rem;
  text-decoration: none;
}

.btn-download {
  background: linear-gradient(90deg, var(--xk-sky-deep), var(--xk-sky));
  color: #fff;
  border-color: transparent;
}

.close-btn {
  width: 2rem;
  height: 2rem;
  border: none;
  border-radius: 50%;
  background: var(--xk-soft);
  color: var(--xk-ink);
  font-size: 1.35rem;
  line-height: 1;
  cursor: pointer;
}

.detail-body {
  position: relative;
  flex: 1;
  min-height: 0;
  background: #f4efe4;
  display: grid;
  place-items: center;
  padding: 0.75rem 3rem;
}

.detail-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  display: block;
  border-radius: 0.35rem;
  box-shadow: 0 10px 28px rgba(40, 30, 10, 0.12);
}

.nav-side {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 2.4rem;
  height: 2.4rem;
  border: none;
  border-radius: 50%;
  background: rgba(15, 40, 70, 0.72);
  color: #fff;
  font-size: 1.6rem;
  line-height: 1;
  cursor: pointer;

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  &.prev {
    left: 0.75rem;
  }

  &.next {
    right: 0.75rem;
  }
}

@media (max-width: 1400px) {
  .image-grid {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}

@media (max-width: 1100px) {
  .image-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media (max-width: 800px) {
  .image-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .detail-body {
    padding: 0.75rem 2.4rem;
  }

  .image-meta span {
    display: none;
  }
}

@media (max-width: 520px) {
  .image-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .detail-head {
    flex-direction: column;
  }
}
</style>
